import { Api, createApi, retry } from '@reduxjs/toolkit/query/react';
import { getGqlBaseQuery, GraphqlQuery } from './helpers/graphql';
import { MENTOR_API_PATH } from './service-paths';

const gqlBaseQuery = getGqlBaseQuery(MENTOR_API_PATH);

export enum MentorGqlApiTagTypes {
  Mentor = 'mentor',
  Agreements = 'agreements',
}

export type MentorGqlApi = Api<
  (
    { document, variables }: GraphqlQuery,
    { getState }: any
  ) => Promise<{ data: any; error?: any } | { error: { status: number; data: any }; data?: any }>,
  Record<string, any>,
  'mentorGqlApi',
  MentorGqlApiTagTypes
>;

export const mentorGqlApi = createApi({
  baseQuery: retry(gqlBaseQuery, {
    maxRetries: 3,
  }) as typeof gqlBaseQuery,
  reducerPath: 'mentorGqlApi',
  tagTypes: Object.values(MentorGqlApiTagTypes),
  endpoints: () => ({}),
});

export const api = mentorGqlApi;
